import { base } from './base.js';
import { deviceID } from './deviceID.js';
import { key } from './key.js';
import { defaultCard } from './default.js';

export const templates = {
  base,
  deviceID,
  key,
  default: defaultCard,
};

export function registerTemplate(name, fn) {
  templates[name] = fn;
}
